import { Component, Input } from "@angular/core";

@Component({
  selector: "times-popover",
  templateUrl: "./times-popover.component.html",
})
export class TimesPopoverComponent {

  @Input() public item: any;

}
